import React from 'react';
import { CustomCursor } from './components/CustomCursor';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { TickerStrip } from './components/TickerStrip';
import { ServicesGrid } from './components/ServicesGrid';
import { HowItWorks } from './components/HowItWorks';
import { AboutSection } from './components/AboutSection';
import { ServiceArea } from './components/ServiceArea';
import { CTABand } from './components/CTABand';
import { Reviews } from './components/Reviews';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="bg-brand-black min-h-screen selection:bg-brand-green selection:text-black" data-id="element-0">
      <CustomCursor data-id="element-1" />
      <Navbar data-id="element-2" />

      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <TickerStrip data-id="element-5" />
        <ServicesGrid data-id="element-6" />
        <HowItWorks data-id="element-7" />
        <AboutSection data-id="element-8" />
        <ServiceArea data-id="element-9" />
        <CTABand data-id="element-10" />
        <Reviews data-id="element-11" />
        <ContactSection data-id="element-12" />
      </main>

      <Footer data-id="element-13" />
    </div>;
}